<template>
  <div
    class="epi-picture loaded"
  >
    <div
      :style="backgroundImageStyle"
      class="epi-background-container"
      :role="description ? 'img' : null"
      :aria-label="description"
    />
  </div>
</template>

<script>
/* One Url Epi Picture
 * This is a non lazy loading, one picture alternative to epi picture.
 * This means we wont be using all three images sent from epi, just the large one.
 * This to provide the image on the server render instead of in the hydration phase.
 * This will serve the image faster and get better SEO score.
 * Normally we have to wait until hydration kicks in (client side) to know which of the images to load.
 */
export default {
  name: "OneUrlEpiPicture",
  props: {
    image: {
      type: Object,
      default: null
    },
    imageUrl: {
      type: String,
      default: ''
    },
    sizes: {
      type: Object,
      default: null
    }
  },
  computed: {
    description () {
      return this.image ? this.image.altText || this.alt : this.alt
    },
    backgroundImageStyle () {
      const imageObj = this.image.large
      const dimensions = this.getDimensions(imageObj)
      const epiDimensions = `w_${this.sizes.large.width},h_${this.sizes.large.height}`
      const epiAsset = imageObj.catalog?.toLowerCase() === 'epi%20assets' || imageObj.provider?.toLowerCase() === 'epi%20assets' ? `cumulus/${imageObj.provider || imageObj.catalog}/${imageObj.id}/` : ''
      const url = `https://assets.icanet.se/w_${dimensions.w},h_${dimensions.h},x_${dimensions.x},y_${dimensions.y},c_crop/${epiDimensions},c_lfill/f_auto,q_auto,dpr_1.0/${epiAsset}${imageObj.filename}`
      return `background-image:url("${url}");`
    }
  },
  methods: {
    getDimensions (img) {
      const {
        left = 0,
        right = 0,
        top = 0,
        bottom = 0,
        width = 0,
        height = 0,
        proportions: { x, y } = {
          proportions: {
          x: 0, y: 0
          }
        }
      } = img || {}

      return {
        w: Math.round((1 - (left + right)) * width),
        h: Math.round((1 - (bottom + top)) * height),
        x: Math.round(x || left * width),
        y: Math.round(y || top * height)
      }
    }
  }
}
</script>
